export default () => {
  const themeOptions = {
    typography: {
      fontSize: 20,
    },
  };
  return themeOptions;
};
